import "./index.scss"
import cn from "classnames"

const Block = ({ children, className, ...rest }) => {
  return (
    <div className={cn("people-block", className)} {...rest}>
      {children}
    </div>
  )
}

export default Block
